export default "__VITE_ASSET__BvTPMQo___"